import { Store, Flame, Sparkles, Shield, Music } from "lucide-react";

const MARKET_META = { icon: Store, color: "#C59B27", hue: "amber" };

export const CATEGORY_META = {
  market: MARKET_META,
  pagan_festival: { icon: Flame, color: "#D97706", hue: "orange" },
  pagan_event: { icon: Sparkles, color: "#8B5CF6", hue: "violet" },
  reenactment: { icon: Shield, color: "#B45309", hue: "amber" },
  concert: { icon: Music, color: "#991B1B", hue: "red" },
  // Legacy aliases (kept so existing events/URLs still render an icon/color under "Marchés")
  medieval_market: MARKET_META,
  viking_market: MARKET_META,
};

// Public, selectable categories (menus, filters). Legacy market slugs are merged into "market".
export const CATEGORY_KEYS = ["market", "pagan_festival", "pagan_event", "reenactment", "concert"];
